export default {"src":"/_next/static/media/paypal.4c207a2f.svg","height":24,"width":75,"blurWidth":0,"blurHeight":0};